import { useEffect, useState } from 'react';

/** @see https://github.com/streamich/use-media/blob/master/src/useMedia.ts */
export default function useMediaQuery(query, defaultMatch = false) {
  const [matchesMedia, setMatchesMedia] = useState(defaultMatch);

  useEffect(() => {
    let mounted = true;
    const mediaQuery = window.matchMedia(query);

    const handleMediaChange = () => {
      if (!mounted) return;
      setMatchesMedia(Boolean(mediaQuery.matches));
    };

    mediaQuery.addEventListener('change', handleMediaChange);

    return () => {
      mounted = false;
      mediaQuery.removeEventListener('change', handleMediaChange);
    };
  }, [query]);

  return matchesMedia;
}
